module.exports = __webpack_public_path__ + "./img/noaccess.49a9014f27f129dcd2806d30cca34e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/noaccess.png
// module id = ./src/containers/Briefcase/entry/icons/noaccess.png
// module chunks = 0